class Warehouse {
	constructor(id, slug, address, price, extraFurnitureCapacity, description) {
		this.id = id;
		this.slug = slug;
		this.address = address;
		this.price = price;
		this.extraFurnitureCapacity = extraFurnitureCapacity;
		this.description = description;
	}

	toPlainObj() {
		return {
			id: this.id,
			slug: this.slug,
			address: this.address,
			price: this.price,
			extraFurnitureCapacity: this.extraFurnitureCapacity,
			description: this.description
		};
	}
}

export default function WarehouseBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withSlug: function (slug) {
			this.slug = slug;
			return this;
		},
		withAddress: function (address) {
			this.address = address;
			return this;
		},
		withPrice: function (price) {
			this.price = price;
			return this;
		},
		withExtraFurnitureCapacity: function (extraFurnitureCapacity) {
			this.extraFurnitureCapacity = extraFurnitureCapacity;
			return this;
		},
		withDescription: function (description) {
			this.description = description;
			return this;
		},
		build: function () {
			return new Warehouse(
				this.id,
				this.slug,
				this.address,
				this.price,
				this.extraFurnitureCapacity,
				this.description
			);
		}
	};
}

export function CreateWarehouseModel(warehouse) {
	return new WarehouseBuilder()
		.withId(warehouse.id)
		.withSlug(warehouse.slug)
		.withAddress(warehouse.address)
		.withPrice(warehouse.price)
		.withExtraFurnitureCapacity(warehouse.extra_furniture_capacity)
		.withDescription(warehouse.description)
		.build().toPlainObj();
}
